import { useEffect } from 'react'
import { Redirect, useLocalSearchParams, useNavigation } from 'expo-router'
import usePayments from '@order/hooks/usePayments'
import PaymentSettings from '@screens/payment/settings'

export default function PaymentSettingsPage() {
  const { id } = useLocalSearchParams<{ id: string }>()

  const payments = usePayments((s) => s.payments)
  const removeDraftPayment = usePayments((s) => s.removeDraftPayment)
  const navigation = useNavigation()
  const payment = id ? payments[id] : undefined

  useEffect(() => {
    const remove = navigation.addListener('beforeRemove', () => {
      if (!id) {
        return
      }
      removeDraftPayment(id)
    })
    return remove
  }, [id, removeDraftPayment, navigation])

  if (!payment) {
    return <Redirect href="/checkout" />
  }

  return <PaymentSettings item={payment} />
}
